var exports = {
  "kL": "xa15a2ab7--10e86c--container",
  "Qs": "xa15a2ab7--10e86c--content",
  "uY": "xa15a2ab7--10e86c--pop",
  "XH": "xa15a2ab7--10e86c--purchase-gift-pop",
  "q2": "xa15a2ab7--10e86c--shine",
  "Lb": "xa15a2ab7--10e86c--purchase-gift-shine",
};

module.exports = exports;
